import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/catalog` — taken down (Robby, 2026-10-26: the catalog was confusing people; it comes
 * back later in a different shape). The address goes home rather than to a 404, because
 * old links and bookmarks still point here. `CatalogPage` stays in the tree for that return.
 *
 * `catalog.index`, not `catalog`: a route file named for the bare segment becomes the
 * parent layout of everything under it, and `/catalog/<slug>` still serves services.
 */
export const Route = createFileRoute("/catalog/")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
